import axiosApi from '../../kits/axiosApi';
import { message } from 'ant-design-vue';

// initial state
const state = {
};

// getters
const getters = {
};

// actions
const actions = {
    getMerchantList({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .get(aj_host + `/weapp/minipass/merchant/list?search=` + post_data.search + '&page=' + post_data.page + '&page_size=20&sort_by=' + post_data.sort_by + '&matched=' + post_data.matched)
                .then((res) => {
                    resolve(res.data.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    updateMerchantStatus({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .get(aj_host + `/weapp/minipass/merchant/status/update?sid=` + post_data.sid + '&enable=' + post_data.enable + '&type=' + post_data.type + '&autojoin_limit=' + post_data.autojoin_limit)
                .then((res) => {
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    getMerchantTopn({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .get(aj_host + `/weapp/minipass/merchant/topn?topn=50`)
                .then((res) => {
                    resolve(res.data.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    doWaitlistCheck({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .get(aj_host + `/weapp/minipass/merchant/waitlist/check?sid=` + post_data.sid + '&check_type=' + post_data.check_type + '&target_date=' + post_data.target_date + '&target_time=' + post_data.target_time + '&people_num=' + post_data.people_num)
                .then((res) => {
                    resolve(res.data.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    getPlaceidData({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .get(aj_host + `/weapp/minipass/merchant/placeid/explain?placeid=` + post_data.placeid)
                .then((res) => {
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    createMerchant({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .post(aj_host + `/weapp/minipass/merchant/create`, post_data)
                .then((res) => {
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    updateMerchant({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .post(aj_host + `/weapp/minipass/merchant/update`, post_data)
                .then((res) => {
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    deleteMerchant({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .get(aj_host + `/weapp/minipass/merchant/del?sid=` + post_data.sid)
                .then((res) => {
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    batchCreateMerchants({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .post(aj_host + `/weapp/minipass/merchant/batch_create`, post_data)
                .then((res) => {
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    getVoiceaiList({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';
        const cluster = post_data.cluster || 'north_america';

        return new Promise((resolve, reject) => {
            axiosApi
                .get(aj_host + `/weapp/minipass/voiceai/list?page=` + (post_data.page || 1) + '&cluster=' + cluster)
                .then((res) => {
                    if (res.data && res.data.code === -1) {
                        reject(new Error(res.data.error || 'request failed'));
                        return;
                    }
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    createVoiceaiMerchant({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .post(aj_host + `/weapp/minipass/voiceai/create`, post_data)
                .then((res) => {
                    if (res.data && res.data.code === -1) {
                        reject(new Error(res.data.error || 'request failed'));
                        return;
                    }
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    updateVoiceaiEnable({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .post(aj_host + `/weapp/minipass/voiceai/enable`, post_data)
                .then((res) => {
                    if (res.data && res.data.code === -1) {
                        reject(new Error(res.data.error || 'request failed'));
                        return;
                    }
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    updateVoiceaiSetting({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .post(aj_host + `/weapp/minipass/voiceai/update`, post_data)
                .then((res) => {
                    if (res.data && res.data.code === -1) {
                        reject(new Error(res.data.error || 'request failed'));
                        return;
                    }
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    updateVoiceaiContact({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .post(aj_host + `/weapp/minipass/voiceai/contact/update`, post_data)
                .then((res) => {
                    if (res.data && res.data.code === -1) {
                        reject(new Error(res.data.error || 'request failed'));
                        return;
                    }
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    deleteVoiceaiMerchant({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .post(aj_host + `/weapp/minipass/voiceai/delete`, post_data)
                .then((res) => {
                    if (res.data && res.data.code === -1) {
                        reject(new Error(res.data.error || 'request failed'));
                        return;
                    }
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    syncVoiceaiStoreInfo({ commit, rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5050' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .post(aj_host + `/weapp/minipass/voiceai/sync`, post_data)
                .then((res) => {
                    if (res.data && res.data.code === -1) {
                        reject(new Error(res.data.error || 'request failed'));
                        return;
                    }
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
};

// mutations
const mutations = {
    
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
